export default class MobileActiveItems {


	// Constructor
	constructor(element, itemSelector) {

		this.element = element;
		this.items = Array.prototype.slice.call(this.element.querySelectorAll(itemSelector), 0);

		this.itemClick = this.itemClick.bind(this);

	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.element;
		delete this.items;
	}
	enable() {
		this.disable();
		for (var i=0, l=this.items.length; i<l; i++) {
			this.items[i].addEventListener('click', this.itemClick);
		}
	}
	disable() {
		for (var i=0, l=this.items.length; i<l; i++) {
			this.items[i].removeEventListener('click', this.itemClick);
		}
	}


	// Event Handlers
	itemClick(event) {
		event.preventDefault();
		const index = this.items.indexOf(event.currentTarget);
		for (var i=0, l=this.items.length; i<l; i++) {
			if (i === index) {
				this.items[i].classList.add('active');
			} else {
				this.items[i].classList.remove('active');
			}
		}
	}

}
